import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  VideoWrapper
} from './styled'

export class Video extends React.PureComponent {
  render () {
    const {
      className,
      srcLink,
      srcFile,
      heightRatio,
      blueFrame,
      grayFrame
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'video',
      className,
      {'is-blue-frame': blueFrame},
      {'is-gray-frame': grayFrame}
    )

    return (
      <VideoWrapper
        className={classes}
        theme={{
          heightRatio
        }}
      >
        {srcLink &&
          <iframe
            className='video-content'
            src={srcLink}
            frameBorder='0'
            allow='autoplay; encrypted-media'
            allowFullScreen
          />
        }

        {srcFile &&
          <video
            controls
            className='video-content'
          >
            <source src={srcFile} type='video/mp4' />
          </video>
        }
      </VideoWrapper>
    )
  }

  static defaultProps = {
    // * If you set new default props, you should create propsType for correct styleguide document.
    heightRatio: 56
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string
  }
}
